import React from 'react';
import { ArrowRight } from 'lucide-react';
import { ProductCard } from '../components/ProductCard';
import { Wave } from '../components/Wave';
import { useSEO } from '../hooks/useSEO';
import { getPageSEO } from '../data/seoData';

export const Products = () => {
  // SEO Configuration
  useSEO(getPageSEO('products'));

  const products = [{
    title: 'QuickCont',
    description: 'Sistema contable integral diseñado para optimizar la gestión financiera de tu empresa. Una solución completa para el control y análisis de tus finanzas.',
    icon: "/quickcont-logo.png",
    path: '/quickcont'
  }, {
    title: 'Facelec+',
    description: 'Solución completa para facturación electrónica que cumple con todas las normativas. Automatiza y simplifica tu proceso de facturación.',
    icon: "/facelec-logo.png",
    path: '/facelec'
  }, {
    title: 'Galenos Web',
    description: 'Sistema integral para la gestión de clínicas y consultorios médicos. Optimiza la administración de tu práctica médica con herramientas especializadas.',
    icon: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
    path: '/galenos'
  }];
  return <div className="w-full">
      <section className="bg-gradient-to-b from-blue-800 via-blue-700 to-blue-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Nuestros Productos
          </h1>
          <p className="text-xl mb-8">
            Explora nuestro catálogo de herramientas tecnológicas diseñadas para
            impulsar tu negocio
          </p>
        </div>
      </section>
      <Wave color="#fff" className="bg-blue-600" pattern="pattern1" />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {products.map((product, index) => <ProductCard key={index} {...product} className="h-full" />)}
          </div>
        </div>
      </section>
    </div>;
};